export default function Hero() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      <div className="hero-ring" />
      <div className="hero-ring hero-ring-2" />

      <div className="hero-diamond" />
      <p className="hero-pre">
        <span className="hero-pre-line" />
        Premium Erkek Kuaförü
        <span className="hero-pre-line" />
      </p>
      <h1 className="hero-title">
        <span className="gold">NİŞANTAŞI</span>
        <span className="thin">Erkek Kuaför Salonu</span>
      </h1>
      <div className="hero-ornament">
        <div className="line" />
        <div className="diamond" />
        <div className="diamond" />
        <div className="diamond" />
        <div className="line" />
      </div>
      <p className="hero-sub">&ldquo; Stilinizi yeniden tasarlıyoruz &rdquo;</p>
      <div className="hero-cta">
        <button className="btn-primary" onClick={() => scrollTo('barbers')}>
          <span className="btn-shine" />
          Randevu Al
        </button>
        <button className="btn-outline" onClick={() => scrollTo('services')}>
          Keşfet
        </button>
      </div>
      <div className="scroll-hint">
        <span>Aşağı Kaydır</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
}
